import { ReactNode, useMemo } from 'react';
import { AnchoredSheetTitleBar } from './AnchoredSheetTitleBar';
import { AnchoredSheetProps } from './props';

export function useTitleBar(
  title?: AnchoredSheetProps['title'],
  renderTitleBar?: AnchoredSheetProps['renderTitleBar'],
): ReactNode {
  return useMemo<ReactNode>(() => {
    if (title) {
      return <AnchoredSheetTitleBar title={title} />;
    }
    if (renderTitleBar) {
      return renderTitleBar();
    }
    return null;
  }, [renderTitleBar, title]);
}
